<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'app',
  created() {
    this.$vuetify.lang.current = 'uk'
    this.$localization.SetLocalization('uk')
  }
}
</script>
<style lang="scss">
  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";
html{
  min-width: 1070px;
  overflow-x: auto !important;
}
</style>